import envJson from './../assets/appSettings.json';
import { EnvironmentSettings } from '../app/shared/models/common.interface';
export const environment: EnvironmentSettings = {
  production: envJson.production ? envJson.production : false,
  name: envJson.name ? envJson.name : 'dev',
  apiUrl: envJson.apiUrl ? envJson.apiUrl : 'https://fb-adminapi-dev.azurewebsites.net',
};
